import useSubmissionsWorkspace from 'broker/pages/SubmissionWorkspacePage/store/useSubmissionWorkspace';

export function useWorkspaceName() {
  const { submission } = useSubmissionsWorkspace();

  return submission?.insuredName;
}
